const FilePenIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H288c8.8 0 16-7.2 16-16V416H192c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32H304c17.7 0 32 14.3 32 32v16h16c8.8 0 16-7.2 16-16V160H320c-17.7 0-32-14.3-32-32V0H64zm256 128h128L320 0V128zm281 177.9L497.9 206c-12.5-12.5-32.8-12.5-45.3 0L288 370.7V464c0 8.8 7.2 16 16 16H433.3L569 329.3c12.5-12.5 12.5-32.8 0-45.4z" />
  </svg>
);

export default FilePenIcon;
